import type { Address } from 'viem'
import { useBytecode } from 'wagmi'

export const useWalletType = (address: Address | undefined) => {
  const { data, isSuccess, isLoading } = useBytecode({
    address,
    query: {
      enabled: !!address,
    },
  })

  return {
    isEOA: isSuccess && !data,
    isSmartContract: isSuccess && !!data,
    isLoading,
    isSuccess,
  }
}
